/**
 * @desc 分页
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.warehouseCost.page.Params, options?: any) {
  return updateResponse(
    http(URL + `/warehouseCost/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
